<template>
  <div
    class="editorial-slider"
    data-aos="fade-up"
    data-aos-duration="400"
    data-aos-easing="ease-in-out"
  >
    <div class="swiper-container" ref="editorialSwiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide lazyload"
          data-sizes="auto"
          :class="{ outline: hasoutline }"
          v-for="(image, index) in images"
          :key="index"
          :data-bgset="image"
        ></div>
      </div>
    </div>
    <div class="swiper-button-prev" ref="prev"></div>
    <div class="swiper-button-next" ref="next"></div>

    <stamp v-if="stamp.stamp_show" :stamp="stamp"></stamp>
  </div>
</template>

<script>
import Swiper from "swiper/dist/js/swiper.js";
import stamp from "./stamp.vue";
export default {
  components: {
    stamp
  },
  props: {
    images: { type: Array || String, required: true },
    hasoutline: { type: Boolean, default: false },
    stamp: { type: Object, required: true }
  },
  mounted() {
    // init swiper
    const editorialSwiper = new Swiper(this.$refs.editorialSwiper, {
      slidesPerView: 1,
      watchOverflow: true,
      speed: 1000,
      effect: "fade",
      autoplay: {
        delay: 3000
      },
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.editorial-slider {
  height: 100%;
  width: 100%;
  .swiper-container {
    width: 100%;
    height: 100%;
    .swiper-slide {
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;
      padding-top: 100%;
      &.outline {
        outline: 1px white solid;
        outline-offset: -35px;

        @include res(tab-p) {
          outline-offset: -18px;
        }
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 30px;
    background-size: contain;
    outline: none;
    top: 92%;
    @include res(tab-l) {
      top: 88%;
    }

    @include res(mobile) {
      top: 80%;
    }
  }
  .swiper-button {
    &-prev {
      right: 65px;
      width: 35px;
      height: 30px;
      left: auto;
      transform: rotate(180deg);
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='25px' height='45px' viewBox='0 0 25 45' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com --%3E%3Ctitle%3EUI/Next%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Module/Funiture' transform='translate(-1372.000000, -371.000000)' stroke='%23FFFFFF'%3E%3Cg id='UI/Next' transform='translate(1373.000000, 372.000000)'%3E%3Cg id='Icons/dropdown_arrow' transform='translate(11.000000, 21.500000) rotate(-90.000000) translate(-11.000000, -21.500000) translate(-10.000000, 11.000000)'%3E%3Cpolyline id='Path-2' stroke-width='3' points='0 0.0245707891 20.9877074 21 42 0'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
    &-next {
      right: 35px;
      width: 35px;
      height: 30px;
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='25px' height='45px' viewBox='0 0 25 45' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com --%3E%3Ctitle%3EUI/Next%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Module/Funiture' transform='translate(-1372.000000, -371.000000)' stroke='%23FFFFFF'%3E%3Cg id='UI/Next' transform='translate(1373.000000, 372.000000)'%3E%3Cg id='Icons/dropdown_arrow' transform='translate(11.000000, 21.500000) rotate(-90.000000) translate(-11.000000, -21.500000) translate(-10.000000, 11.000000)'%3E%3Cpolyline id='Path-2' stroke-width='3' points='0 0.0245707891 20.9877074 21 42 0'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
  }
}
</style>
